<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit.prevent="filtrarFunc"
  >
    <v-row>
      <v-col
        cols="12"
        lg="8"
      >
        <v-select
          :v-model="objSelect"
          :items="listaSelect"
          item-text="nome"
          item-value="id"
          :success="true"
          :disabled="disabledSelect"
          return-object
          :label="labelSelect"
          @change="onChange($event)"
        />
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <v-menu
          ref="menuData"
          v-model="menuData"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="computedDateFormatted"
              v-mask="maskDateFormatted"
              :rules="DateFormattedRules"
              :disabled="disabledSelectDate"
              :success="true"
              :label="labelSelectDate"
              v-on="on"
            >
              <template
                v-if="true"
                v-slot:append-outer
              >
                <v-btn
                  :disabled="!valid"
                  class="mt-n2"
                  elevation="1"
                  fab
                  small
                  color="primary"
                  type="submit"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            type="month"
            no-title
            @input="menuData = false"
          />
        </v-menu>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
  import utils from '../../../../services/utils'
  export default {
    name: 'DashboardCoreFiltro',
    mixins: [utils],
    props: {
      listaSelect: {
        type: Array,
        default: function () {
          return []
        },
      },
      selectedId: {
        type: Number,
        default: 0,
      },
      labelSelect: {
        type: String,
        default: 'Select...',
      },
      labelSelectDate: {
        type: String,
        default: 'Select Date...',
      },
      selectedDate: {
        type: String,
        default: '',
      },
      disabledSelect: {
        type: Boolean,
        default: false,
      },
      filtrarFunc: {
        type: Function,
        default: null,
      },
    },

    data: () => ({
      id: 0,
      date: new Date().toISOString().substr(0, 10),
      objSelect: {},
      items: [],
      label: '',
      disabledSelectDate: false,
      // disabledSelect: false,
      valid: true,
      menuData: false,
      maskDateFormatted: '##/####',
      DateFormattedRules: [
        v => /^\d{2}\/\d{4}$/.test(v),
      ],
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
    },

    watch: {
      selectedId: function (val) {
        this.id = val
      },
      selectedDate: function (val) {
        this.Date = val
      },
      id: function (val) {
        this.$emit('update-selected-id', this.id)
      },
      date: function (val) {
        this.$emit('update-selected-date', this.date)
      },
      disabledSelect: function (val) {
        // console.log('aaaaaaaaaaaa ' + this.disabledSelect)
        // this.disabledSelect = true
        this.objSelect = this.listaSelect[0]
        this.label = 'sdfsdfsd' // this.listaSelect[0].nome
      },
    },

    methods: {
      onChange (event) {
        this.objSelect = event
        this.id = this.objSelect.id
        console.log('onchange', this.id)
      },
    },

  }
</script>

<style>

</style>
